





























































































































































































import {PreprocessingRuleItem} from '@/store/settings/preprocessing_rules/types';
import {Component, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {ScrollButton} from "wings-ui-components";
import PreprocessingRulesFilter from "@/components/Settings/PreprocessingRules/PreprocessingRulesFilter.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import draggable from 'vuedraggable'
import {cloneDeep, isEqual} from "lodash";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {ScrollButton, PreprocessingRulesFilter, draggable}})
export default class PreprocessingRules extends BaseItemsPage<PreprocessingRuleItem> {
  @Getter("preprocessingRules") preprocessingRulesResponse: any;
  @Action("savePreprocessingPriority") savePreprocessingPriority: any;
  @Action("actionLog") actionLog: any;

  private is_show_filter = false;
  private modelDragon: any = [];
  private logObject: ActionLog = {};

  currentSortOrder = "asc";

  tableFields = ['partner', 'account', 'channel', 'originator', 'template', 'rule', 'position'];

  getData(): any {
    this.modelDragon = cloneDeep(this.preprocessingRulesResponse);
    return this.preprocessingRulesResponse;
  }


  @Watch('modelDragon', {immediate: false, deep: true})
  async onModelChange(new_val: any, old_val:any) {
    if (!isEqual(new_val, old_val) && old_val.length) {
      try {
        const new_ids: number[] = [];
        new_val.forEach((e: any) => new_ids.push(Number(e.id)));
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Editing",
          action_status: "success",
          object_type: "Additional processing rule",
          addititional_info: getTranslatedParams({rules_order_by_priority: new_ids})
        }
        await this.savePreprocessingPriority({additional_processing_rules: new_ids});
        await this.actionLog(this.logObject);
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

};
